import ImportListProductPricingTab from './ImportListProductPricingTab'

export default ImportListProductPricingTab
